import { Badge } from "@/components/ui/badge";
import { Crown, Shield, Clock, CheckCircle } from "lucide-react";

interface PremiumStatusBadgeProps {
  isPremium: boolean;
  premiumSource: 'subscription' | 'override' | null;
  isAdmin: boolean;
  trialDaysRemaining: number;
  trialExpired: boolean;
}

export function PremiumStatusBadge({
  isPremium,
  premiumSource,
  isAdmin,
  trialDaysRemaining,
  trialExpired
}: PremiumStatusBadgeProps) {
  if (isAdmin) {
    return (
      <Badge variant="default" className="gap-1 bg-purple-500 hover:bg-purple-600">
        <Shield className="h-3 w-3" />
        Admin
      </Badge>
    );
  }

  if (isPremium) {
    if (premiumSource === 'subscription') {
      return (
        <Badge variant="default" className="gap-1 bg-green-500 hover:bg-green-600">
          <Crown className="h-3 w-3" />
          Premium
        </Badge>
      );
    }
    if (premiumSource === 'override') {
      return (
        <Badge variant="default" className="gap-1 bg-blue-500 hover:bg-blue-600">
          <CheckCircle className="h-3 w-3" />
          Override
        </Badge>
      );
    }
  }

  if (trialExpired) {
    return (
      <Badge variant="destructive" className="gap-1">
        <Clock className="h-3 w-3" />
        Trial Expired
      </Badge>
    );
  }

  if (trialDaysRemaining <= 7) {
    return (
      <Badge variant="secondary" className="gap-1 bg-yellow-500 hover:bg-yellow-600 text-white">
        <Clock className="h-3 w-3" />
        {trialDaysRemaining}d left
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="gap-1">
      <Clock className="h-3 w-3" />
      Trial ({trialDaysRemaining}d)
    </Badge>
  );
}
